import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {UserService} from "../../../../@shared/services/user.service";
import {environment} from "../../../../../environments/environment";
import {Clipboard} from "@angular/cdk/clipboard";
import {FastOfferOrderStatusEnum} from "../../../+payouts-by-skins/enums/fast-offer-order-status.enum";
import {IPayoutBySkins} from "../../../+payouts-by-skins/intefaces/payouts-by-skins.interface";

export interface IGoFastWithdraw {
  comment: string;
  id: number | string;
  state: string | number;
  wallet: string;
  amount: number;
  error: string;

  img: string;
  name: string;

  reason: string | null;
  seller: number | null;
  fast_deliver?: boolean | null;
  system: string;
  timestamp: string;
}

export interface IHltvWithdraw {
  "id": number,
  "createdAt": string,
  "updatedAt": string,
  "approved": boolean,
  "game": string, //
  "agent": string, //
  "userInventoryItemId": string,
  "userId": number, //
  "amount": number,
  "state": number,
  "shown": false //
}

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit, AfterViewInit {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public fastOfferOrderStatusEnum = FastOfferOrderStatusEnum;
  withdrawColumns: string[];
  userWithdrawals: MatTableDataSource<IGoFastWithdraw | IHltvWithdraw> = new MatTableDataSource<IGoFastWithdraw | IHltvWithdraw>();
  public isLoading: boolean = true;

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;

  constructor(private userService: UserService,
              public clipboard: Clipboard) {
    this.withdrawColumns = this.isGoFast
      ? ['id', 'state', 'amount', 'system', 'seller-wallet', 'name', 'timestamp', 'comment']
      : ['id', 'createdAt', 'approved', 'userInventoryItemId', 'amount', 'state'];
  }

  ngOnInit() {
    this.userService.getUserWithdrawals().subscribe((data: (IGoFastWithdraw[] | IHltvWithdraw[])) => {
      this.isLoading = false;
      const sortField = this.isGoFast ? 'timestamp' : 'createdAt';
      this.userWithdrawals.data = data
        .map((item: IGoFastWithdraw | IHltvWithdraw) => ({
          ...item,
          statusText: this.setStatusTextById(item.state),
        }))
        .sort((a: any, b: any) => new Date(b[sortField] || 0).getTime() - new Date(a[sortField] || 0).getTime());
    }, () => this.isLoading = false);
  }

  ngAfterViewInit() {
    this.userWithdrawals.paginator = this.paginator;
    this.userWithdrawals.sort = this.sort;
  }

  // потому что статусов приходит много и все они какая-то шляпа, а тут сразу понятно =)
  public setStatusTextById(state: (number | string)): string {
    if (typeof state === 'string') return state;

    if ([1, 2, 3, 4, 'waiting'].includes(state)) {
      return 'waiting';
    }

    if ([10, 'success'].includes(state)) {
      return 'success';
    }

    return 'error'
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userWithdrawals.filter = filterValue.trim().toLowerCase();

    if (this.userWithdrawals.paginator) {
      this.userWithdrawals.paginator.firstPage();
    }
  }
}
